import { Button, Form } from 'react-bootstrap'
import styled, { css } from 'styled-components'

// Special style for Account Settings title in VehicleStickyBar
const accountSettingsTitleStyles = css`
  font-size: 18px;
`

const formElementStyles = css`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.fontColor || '#495057'};
`

export const AccountSettingStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.backgroundText};
  margin-left: 2.4rem;
  margin-right: 2.4rem;
  margin-bottom: 2.4rem;
  flex: 1;

  .add-icon {
    font-size: 2rem;
  }

  .form-group {
    margin-bottom: 1.5rem;
  }

  .border-bottom {
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.tableBorder || '#dee2e6'};
  }

  /* Enhanced checkbox styling */
  .checkbox-group {
    margin-top: 1rem;

    .form-check {
      margin-bottom: 1rem;

      .form-check-input {
        margin-right: 1rem;
      }

      .form-check-label {
        padding-left: 0.5rem;
        line-height: 1.5;
        ${formElementStyles}
      }
    }
  }

  /* Form styling improvements */
  .form-section {
    margin-bottom: 2rem;

    .form-group {
      margin-bottom: 1.5rem;

      label {
        font-weight: 500;
        margin-bottom: 0.5rem;
        ${formElementStyles}
      }
    }
  }

  /* Link styling */
  .click-text {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
    font-weight: 500;
    font-size: 16px;

    &:hover {
      color: ${({ theme }) => theme.colors.linkColorLight};
      text-decoration: none;
    }
  }

  /* General text styling */
  .form-control,
  .form-text {
    font-size: 13px;
  }
`

export const AccountSettingsContents = styled.div`
  width: 100%;
  max-width: 50%;
  margin-bottom: 2rem;

  .note {
    font-style: italic;
    color: ${({ theme }) => theme.colors.issueColor || 'red'};
    margin-bottom: 2rem;
    font-size: 1.3rem;
  }

  .padding-left {
    padding-left: 1.5rem;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
`

export const SettingsSection = styled.div`
  margin-bottom: 3rem;

  &:last-child {
    margin-bottom: 1rem;
  }
`

export const UpdateButton = styled(Button)`
  height: 3rem;
  width: 10rem;
  margin-top: 1rem;
  line-height: 1.2;
  font-size: 16px;
`

export const CancelButton = styled.div`
  margin-top: auto;
  margin-right: 2rem;
  display: inline-block;
  vertical-align: bottom;
`

export const GroupButtonStyled = styled(Form.Group)`
  float: right;
`

export const Title = styled.h2`
  &&& {
    color: ${({ theme }) => theme.colors.primary} !important;
    font-size: 3rem !important;
    margin-bottom: 1.2rem;
    font-weight: normal;
    line-height: 1.2;
  }

  &&& * {
    font-size: 3rem !important;
    color: ${({ theme }) => theme.colors.primary} !important;
  }
`
export const SectionTitle = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 2rem;
  margin-top: 1rem;
  margin-bottom: 3rem;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
`

export const CarfaxSignOutLink = styled.a<{ $isLoggedIn: boolean }>`
  color: ${({ $isLoggedIn, theme }) => ($isLoggedIn ? theme.colors.primary : theme.colors.fontColor || '#6c757d')};
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  cursor: ${({ $isLoggedIn }) => ($isLoggedIn ? 'pointer' : 'default')};
  opacity: ${({ $isLoggedIn }) => ($isLoggedIn ? 1 : 0.6)};

  &:hover {
    color: ${({ $isLoggedIn, theme }) =>
      $isLoggedIn ? theme.colors.linkColorLight : theme.colors.fontColor || '#6c757d'};
    text-decoration: none;
  }

  &:focus {
    color: ${({ $isLoggedIn, theme }) =>
      $isLoggedIn ? theme.colors.linkColorLight : theme.colors.fontColor || '#6c757d'};
    text-decoration: none;
    outline: none;
  }

  &:active {
    color: ${({ $isLoggedIn, theme }) =>
      $isLoggedIn ? theme.colors.linkColorLight : theme.colors.fontColor || '#6c757d'};
    text-decoration: none;
  }
`

export const MainContainer = styled.div`
  width: 60%;
  margin: 2rem auto 0 auto;
  background-color: white;
`

export const AddLocationLink = styled.a`
  font-size: inherit !important;
  font-weight: normal !important;
`
